import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/linkForm/styles.scss';export default {
  "form": "_form_z8i1u_1",
  "attribute": "_attribute_z8i1u_9"
};